// this is used to communicate events across the app
var eventBus = new Vue();

module.exports = eventBus;



// WEBPACK FOOTER //
// ./lib/eventBus.js